import React from "react";

import barkleyLogo from "../../../resources/images/barkley-logo.svg";
import fiveHundred from "../../../resources/images/fiveHundred.svg";
import forbesImage from "../../../resources/images/forbes-text.svg";
import entrepreneurImage from "../../../resources/images/entrepreneur-text.svg";
import bloombergImage from "../../../resources/images/bloomberg-text.svg";

// width="412" height="149"

import {
  StyledContainer,
  StyledLogoContainer,
  StyledGroupContainer,
  StyledLeftContainer,
  StyledRightContainer,
  StyledHr,
  StyledFiveHundredLogoContainer,
  StyledBarkleyLogoContainer,
} from "./ProudOfMemberStyle";

const ProudOfMember = () => {
  return (
    <StyledContainer>
      <StyledGroupContainer>
        <StyledLeftContainer>
          <StyledBarkleyLogoContainer>
            <img src={barkleyLogo} alt={""} />
          </StyledBarkleyLogoContainer>
          <StyledFiveHundredLogoContainer>
            <img src={fiveHundred} alt={""} />
          </StyledFiveHundredLogoContainer>
        </StyledLeftContainer>
        <StyledHr />
        <StyledRightContainer>
          <StyledLogoContainer>
            <img src={forbesImage} alt={""} />
          </StyledLogoContainer>
          <StyledLogoContainer>
            <img src={entrepreneurImage} alt={""} />
          </StyledLogoContainer>
          <StyledLogoContainer>
            <img src={bloombergImage} alt={""} />
          </StyledLogoContainer>
        </StyledRightContainer>
      </StyledGroupContainer>
    </StyledContainer>
  );
};

export default ProudOfMember;
